<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : activeStep == step }" (click)="toggleOpen()">
        <span class="margin-right">Documentation</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">If applicable, upload the Final As Drilled Plat:</span>
      @if (fieldHasNotes('documentation|finalAsDrilledPlat') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|finalAsDrilledPlat'" [notes]="getFilteredNotes('documentation|finalAsDrilledPlat')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'finalAsDrilledPlat'" [allowUpload]="finalPlatCtrl?.enabled" [files]="finalPlatFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="finalPlatCtrl?.enabled" (fileRemoved)="finalPlatFileRemoved($event)" (newFilesList)="finalPlatFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">If applicable, upload the Preliminary As Drilled Plat (well is directional or horizontal and drilled to total depth, but is not perforated and producing yet):</span>
      @if (fieldHasNotes('documentation|preliminaryPlat') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|preliminaryPlat'" [notes]="getFilteredNotes('documentation|preliminaryPlat')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'preliminaryPlat'" [allowUpload]="preliminaryPlatCtrl?.enabled" [files]="preliminaryPlatFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="preliminaryPlatCtrl?.enabled" (fileRemoved)="preliminaryPlatFileRemoved($event)" (newFilesList)="preliminaryPlatFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">If applicable, upload the Revised Unit Plat:</span>
      @if (fieldHasNotes('documentation|revisedUnitPlat') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|revisedUnitPlat'" [notes]="getFilteredNotes('documentation|revisedUnitPlat')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'revisedUnitPlat'" [allowUpload]="revisedUnitCtrl?.enabled" [files]="revisedUnitFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="revisedUnitCtrl?.enabled" (fileRemoved)="revisedPlatFileRemoved($event)" (newFilesList)="revisedPlatFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">If applicable, upload the Borehole Deviation Survey:</span>
      @if (fieldHasNotes('documentation|boreholeDeviationSurvey') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|boreholeDeviationSurvey'" [notes]="getFilteredNotes('documentation|boreholeDeviationSurvey')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'boreholeDeviationSurvey'" [allowUpload]="boreholeDeviationCtrl?.enabled" [files]="boreholeDeviationFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="boreholeDeviationCtrl?.enabled" (fileRemoved)="boreholeFileRemoved($event)" (newFilesList)="boreholeFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">If applicable, upload Royalty Interest List:</span>
      @if (fieldHasNotes('documentation|royaltyInterestList') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|royaltyInterestList'" [notes]="getFilteredNotes('documentation|royaltyInterestList')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'royaltyInterestList'" [allowUpload]="royaltyCtrl?.enabled" [files]="royaltyFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="royaltyCtrl?.enabled" (fileRemoved)="royaltyFileRemoved($event)" (newFilesList)="royaltyFileAdded($event)"></upload-view-files>
    </div>

  </div>
</ng-container>